import { $qs, $qsa } from '../../utils/QuerySelector';
import { media } from '../../utils/MediaQueries';
import gsap from 'gsap';



function openCurrentPageMenu(menu) {
    const topLevelItems = $qsa('.main-menu .menu-item-has-children', menu);

    topLevelItems && [...topLevelItems].forEach(item => {
        const link = $qs('a', item);
        if (item.classList.contains('current-page-ancestor')) {
            link.click();
        }
    });
}

function handleMenuTriggerClick() {
    const body = $qs('body');
    const _this = $qs('[data-target="menu-trigger"]');
    const menu = $qs('[data-target="menu"]');
    const headerMenu = $qs('[data-target="header-menu"]');
    const topLevelItems = $qsa('[data-target="menu"] .main-menu > li');
    const hamburgerLines = $qsa('span', _this);
    const menuCover = $qs('[data-target="menu-cover"]');
    const { state } = _this.dataset;

    const timeline = gsap.timeline({
        onStart: () => {
            menuCover.dataset.state = state === 'closed' ? 'open' : 'closed';
        },
        onComplete: () => {
            menu.dataset.state = state === 'closed' ? 'open' : 'closed';

            if (state === 'open') {
                body.classList.remove('overflow-hidden');
            }
        }
    });

    _this.dataset.state = state === 'closed' ? 'open' : 'closed';

    timeline.addLabel('start');
    if (state === 'closed') {
        body.classList.add('overflow-hidden');

        timeline
            .to(menu, {
                x: '0%',
            }, 'start')
            // .to(headerMenu, {
            //     autoAlpha: 0
            // }, 'start')
            // .fromTo(topLevelItems,
            //     { alpha: 0, y: 50 },
            //     { alpha: 1, y: 0, stagger: 0.05 },
            //     '<+0.4'
            // );

        openCurrentPageMenu(menu);
    } else {
        timeline
            .to(menu, {
                x: '100%'
            }, 'start')
            // .to(headerMenu, {
            //     autoAlpha: 1
            // }, 'start')
    }
}

function handleTopLevelItemClick(item, event) {
    event.preventDefault();
    
    const { id } = item.dataset;
    const parent = item.closest('li');
    const menu = $qs('[data-target="menu"]');
    const topLevelItems = $qsa('[data-target="menu"] .menu-item-has-children');
    const allSubMenus = $qsa('[data-target="sub-menu"]');
    const subMenu = $qs(`[data-target="sub-menu"][data-id="${id}"]`);
    const subMenuItems = $qsa('li', subMenu);
    const widestSubMenu = [...allSubMenus].reduce((a, b) => a.getBoundingClientRect().width > b.getBoundingClientRect().width ? a : b);

    const subMenuWidth = widestSubMenu.getBoundingClientRect().width;

    [...allSubMenus].forEach(menu => menu.style.width = `${subMenuWidth}px`);

    const timeline = gsap.timeline({});

    // remove open state for all top level items and set clicked item to open
    [...topLevelItems].forEach(item => item.dataset.state = 'closed');
    parent.dataset.state = 'open';

    [...allSubMenus].forEach(menu => menu.dataset.state = 'closed');
    subMenu.dataset.state = 'open';

    timeline
        .addLabel('start')
        .to(menu, {
            x: `-${media.xl ? subMenuWidth : window.innerWidth}px`
        })
        .to(allSubMenus, {
                opacity: 0,
                duration: 0.3,
                ease: 'none'
            }, '<')
        .to(subMenu, {
            opacity: 1,
            duration: 0.3,
            ease: 'none'
        }, '<')
        // .fromTo(subMenuItems,
        //     { alpha: 0, y: 50 },
        //     { alpha: 1, y: 0, stagger: 0.1 },
        //     '<+0.4'
        // );
}

function handleThirdLevelTriggerClick() {
    const parentSecondLevelItem = this.closest('li');
    const allSecondLevelItems = $qsa('ul.children');
    const matchingThirdLevelMenu = $qs('ul.children', parentSecondLevelItem);

    $(allSecondLevelItems).not(matchingThirdLevelMenu).slideUp();
    $(matchingThirdLevelMenu).slideToggle();
}

function handleMobileBackButtonClick() {
    const menu = $qs('[data-target="menu"]');
    const allSubMenus = $qsa('[data-target="sub-menu"]');

    const timeline = gsap.timeline({});

    timeline
        .addLabel('start')
        .to(menu, {
            x: '0%'
        })
        // .to(allSubMenus, {
        //     opacity: 0,
        //     duration: 0.3,
        //     ease: 'none'
        // }, '<')
}

function headerMenuDropdownClick() {
    const headerMenuDropdown = $qs('[data-target="header-menu-dropdown"]');

    headerMenuDropdown.dataset.state = headerMenuDropdown.dataset.state === 'closed' ? 'open' : 'closed';
}
 
function menu() {
    const menuTrigger = $qs('[data-target="menu-trigger"]');
    const topLevelItems = $qsa('[data-target="menu"] .menu-item-has-children > a');
    const thirdLevelTriggers = $qsa('[data-target="third-level-trigger"]');
    const allSecondLevelItems = $qsa('ul.children');
    const menuCover = $qs('[data-target="menu-cover"]');
    const headerMenuDropdownTrigger = $qs('[data-target="header-menu-dropdown-trigger"]');
    const mobileBackButtons = $qsa('[data-target="mobile-back-button"]');

    $(allSecondLevelItems).slideUp();

    menuTrigger.addEventListener('click', handleMenuTriggerClick, false);
    menuCover.addEventListener('click', handleMenuTriggerClick, false);
    topLevelItems.forEach(item => item.addEventListener('click', e => handleTopLevelItemClick(item, e), false));
    thirdLevelTriggers.forEach(trigger => trigger.addEventListener('click', handleThirdLevelTriggerClick, false));
    mobileBackButtons.forEach(button => button.addEventListener('click', handleMobileBackButtonClick, false));
    headerMenuDropdownTrigger.addEventListener('click', headerMenuDropdownClick, false);
}

export default menu;